module.exports = "/_next/static/images/newsDetailBg-dc5589897aa66a93997b0dcbbb2d53f7.webp";